import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Mail } from 'lucide-react';

export default function Footer() {
  const { t, localePath } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-white/10" style={{ backgroundColor: '#0A0A0A' }}>
      <div className="mx-auto max-w-[1120px] px-4 sm:px-6 lg:px-8 py-10 sm:py-12 md:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="col-span-2 sm:col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3 sm:mb-4">
              <img src="/logo.png" alt="Anyelo Elite" className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg object-cover" />
              <span className="text-white font-semibold text-base sm:text-lg" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Anyelo Elite
              </span>
            </div>
            <p className="text-[0.8125rem] sm:text-sm text-white/50 leading-relaxed max-w-[280px]">
              {t('footer_tagline')}
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-white font-semibold text-[0.8125rem] sm:text-sm mb-3 sm:mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              {t('footer_links')}
            </h3>
            <ul className="space-y-2 sm:space-y-2.5">
              <li><Link to={localePath('/')} className="text-[0.8125rem] sm:text-sm text-white/50 hover:text-white transition-colors duration-200">{t('nav_home')}</Link></li>
              <li><Link to={localePath('/support')} className="text-[0.8125rem] sm:text-sm text-white/50 hover:text-white transition-colors duration-200">{t('nav_support')}</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold text-[0.8125rem] sm:text-sm mb-3 sm:mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              {t('footer_legal')}
            </h3>
            <ul className="space-y-2 sm:space-y-2.5">
              <li><Link to={localePath('/privacy')} className="text-[0.8125rem] sm:text-sm text-white/50 hover:text-white transition-colors duration-200">{t('nav_privacy')}</Link></li>
              <li><Link to={localePath('/terms')} className="text-[0.8125rem] sm:text-sm text-white/50 hover:text-white transition-colors duration-200">{t('nav_terms')}</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-2 sm:col-span-1">
            <h3 className="text-white font-semibold text-[0.8125rem] sm:text-sm mb-3 sm:mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              {t('footer_contact')}
            </h3>
            <ul className="space-y-2 sm:space-y-2.5">
              <li>
                <a href="mailto:support@anyelo.es" className="flex items-center gap-2 text-[0.8125rem] sm:text-sm text-white/50 hover:text-white transition-colors duration-200">
                  <Mail size={14} className="shrink-0" />
                  support@anyelo.es
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-8 sm:mt-10 md:mt-12 pt-6 sm:pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">
          <p className="text-xs text-white/40">
            &copy; {currentYear} Anyelo Elite. {t('footer_rights')}
          </p>
          <div className="flex items-center gap-4">
            <Link to={localePath('/privacy')} className="text-xs text-white/40 hover:text-white/60 transition-colors duration-200">
              {t('nav_privacy')}
            </Link>
            <Link to={localePath('/terms')} className="text-xs text-white/40 hover:text-white/60 transition-colors duration-200">
              {t('nav_terms')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
